import { FC } from 'react';

import { ImagesApp } from '../../constants/images';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import * as Style from './styles.tags';

const Promotional: FC = () => {
  const { translate } = useI18nContext();
  return (
    <Style.Promotional id="promotional-tag">
      <img id="promotional-tag-image" src={ImagesApp.svg.coupon} alt="Promotional" />
      <span id="promotional-tag-text">{translate(['TAGS', 'PROMOTIONAL'])}</span>
    </Style.Promotional>
  );
};

export default Promotional;
